export enum UserGroupEnum {
    ADMINISTRADOR = 'ADMINISTRADOR',
    TRIAGEM = 'TRIAGEM',
    CIDADAO = 'CIDADAO',
    DIRETOR_DEPARTAMENTO = 'DIRETOR DEPARTAMENTO',
    MEMBRO_DEPARTAMENTO = 'MEMBRO DEPARTAMENTO',
    ADMINISTRADOR_ORGAO = 'ADMINISTRADOR ORGAO',
    COORDENADOR_ADMINISTRACAO_TRIBUTARIA = 'COORDENADOR ADMINISTRACAO TRIBUTARIA'
}